import axios from 'axios';
import { GET_FORMULA_INSTANCES, ADD_OR_EDIT_FORMULA_INSTANCE, DELETE_FORMULA_INSTANCE, FORMULA_INSTANCES_LOADING, CLEAR_FORMULA_INSTANCES } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IFormula_instance } from '../../types/interfaces';
import store from '../store';

export const getFormula_instances = (comId: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: FORMULA_INSTANCES_LOADING
  });
  axios
    .get('/api/formulainstances', {...tokenConfig(getState), params: {comId}})
    .then(res =>
      dispatch({
        type: GET_FORMULA_INSTANCES,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getUsedFormula = async (comId: number, societeId: number, typeVente: string) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/formulainstances/usedFormula', {...tokenConfig(store.getState), params: {comId, societeId, typeVente}})
    .then(res =>
      resolve(res?.data)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const addOrEditFormula_instance = (comId: number | null, projectId: any, typesVente: string[], isFullTypes: number, formulaId: number, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/formulainstances', {comId, projectId, typesVente, isFullTypes, formulaId, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_OR_EDIT_FORMULA_INSTANCE,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const changeFormulaInstance = async (userId: number, projectId: any, typesVente: string[], formulaId: number) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .post('/api/formulainstances/changeFormulaInstance', {userId, projectId, typesVente, formulaId}, tokenConfig(store.getState))
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const deleteFormula_instance = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/formulainstances/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_FORMULA_INSTANCE,
        payload: id
      })
      callback(id)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const setFormula_instancesLoading = () => {
  return {
    type: FORMULA_INSTANCES_LOADING
  };
};

export const clearFormula_instances = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_FORMULA_INSTANCES
  })
};